
import { ResumeExperiencePositionSoftware } from '@/models/Resume'
import { computed, defineComponent, PropType } from 'vue'

function getImgUrl(image: string) {
    const images = require.context('@/../resume/apps/', false)
    return images('./' + image)
 }

export default defineComponent({
    name: "experience-position-software",
    props: {
        software: {
            type: Object as PropType<ResumeExperiencePositionSoftware>,
            required: true
        } 
    },
    computed: {
        icon(): string {
            return getImgUrl(this.software!.icon)
        },
        isLink(): boolean {
            return this.software!.url != null
        }
    }
})
